module.exports = __webpack_public_path__ + "static/media/minus-button-with-color.44459ba3.svg";